import React, { useState } from "react";
import { HiStar, HiThumbUp, HiChatAlt2, HiChevronDown } from "react-icons/hi";

const FeedbackSection = ({ serviceId }) => {
    // Sample Data
    const feedbackData = {
        averageRating: 4.85,
        totalReviews: 80000,
        starDistribution: {
            5: 76000,
            4: 2000,
            3: 658,
            2: 481,
            1: 2000,
        },
        reviews: [
            {
                name: "Akash Verma",
                date: "Jan 29, 2025",
                service: "360 AC Protect",
                rating: 5,
                comment: "The service exceeded my expectations. Extremely professional and thorough.",
            },
            {
                name: "Sarah Johnson",
                date: "Jan 30, 2025",
                service: "Full Home Deep Clean",
                rating: 5,
                comment: "Absolutely brilliant! My home looks brand new. The team was punctual and polite.",
            },
            {
                name: "John Miller",
                date: "Feb 1, 2025",
                service: "Deep Cleaning",
                rating: 5,
                comment: "Best cleaning service in the city. Reliable and top-notch quality standards.",
            },
            {
                name: "Emily Smith",
                date: "Feb 2, 2025",
                service: "Sofa Cleaning",
                rating: 5,
                comment: "Great results, highly recommend for any premium upholstery work!",
            },
        ],
    };

    const [visibleReviews, setVisibleReviews] = useState(2);

    return (
        <div className="space-y-10">
            {/* Header / Summary */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 pb-8 border-b border-border">
                <div className="flex items-center gap-6">
                    <div className="w-24 h-24 rounded-[2rem] bg-primary flex flex-col items-center justify-center text-white shadow-xl shadow-primary/20">
                        <span className="text-3xl font-black">{feedbackData.averageRating}</span>
                        <div className="flex scale-75 -mt-1">
                            {[1, 2, 3, 4, 5].map(s => <HiStar key={s} />)}
                        </div>
                    </div>
                    <div className="space-y-1">
                        <h4 className="text-xl font-bold">Overall Rating</h4>
                        <p className="text-sm text-muted-foreground font-medium uppercase tracking-widest">
                            Based on {feedbackData.totalReviews.toLocaleString()} experiences
                        </p>
                    </div>
                </div>

                <div className="flex-grow max-w-md w-full space-y-3">
                    {[5, 4, 3, 2, 1].map((stars) => {
                        const count = feedbackData.starDistribution[stars];
                        const percentage = (count / feedbackData.totalReviews) * 100;
                        return (
                            <div key={stars} className="flex items-center gap-4 text-xs font-black">
                                <span className="w-4 text-muted-foreground">{stars}</span>
                                <div className="flex-grow h-2 bg-secondary rounded-full overflow-hidden">
                                    <div 
                                        className="h-full bg-primary transition-all duration-1000 ease-out" 
                                        style={{ width: `${percentage}%` }}
                                    ></div>
                                </div>
                                <span className="w-12 text-right text-muted-foreground">{count.toLocaleString()}</span>
                            </div>
                        )
                    })}
                </div>
            </div>

            {/* Filters */}
            <div className="flex flex-wrap gap-2">
                {["All Reviews", "Positive", "Frequent Users", "Verified"].map((filter, i) => (
                    <button 
                        key={i}
                        className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${i === 0 ? 'bg-primary text-white shadow-lg' : 'bg-secondary text-muted-foreground hover:bg-border'}`}
                    >
                        {filter}
                    </button>
                ))}
            </div>

            {/* Reviews List */}
            <div className="grid gap-6">
                {feedbackData.reviews.slice(0, visibleReviews).map((review, index) => (
                    <div key={index} className="p-8 rounded-[2rem] bg-secondary/30 border border-transparent hover:border-primary/10 transition-all duration-500 group">
                        <div className="flex items-center justify-between mb-4">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 rounded-2xl bg-white shadow-sm flex items-center justify-center text-primary font-black uppercase tracking-widest text-lg">
                                    {review.name.charAt(0)}
                                </div>
                                <div>
                                    <h5 className="font-bold text-base">{review.name}</h5>
                                    <p className="text-[10px] font-black text-muted-foreground uppercase tracking-widest">Managed by Premium Team</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-1 text-accent">
                                {[...Array(review.rating)].map((_, i) => <HiStar key={i} size={18} />)}
                            </div>
                        </div>
                        
                        <p className="text-foreground/80 leading-relaxed font-medium">"{review.comment}"</p>
                        
                        <div className="mt-6 pt-6 border-t border-border/50 flex items-center justify-between text-[10px] font-black uppercase tracking-widest text-muted-foreground">
                            <div className="flex items-center gap-4">
                                <span className="flex items-center gap-1.5"><HiChatAlt2 size={14} className="text-primary" /> {review.service}</span>
                                <span className="flex items-center gap-1.5 opacity-50"><HiThumbUp size={14} /> Helpful</span>
                            </div>
                            <span>{review.date}</span>
                        </div>
                    </div>
                ))}
            </div>

            {/* View More */}
            {visibleReviews < feedbackData.reviews.length && (
                <div className="flex justify-center pt-4">
                    <button 
                        onClick={() => setVisibleReviews(v => v + 2)}
                        className="flex items-center gap-2 px-8 py-4 rounded-2xl bg-white border border-border text-xs font-black uppercase tracking-widest hover:border-primary hover:text-primary transition-all shadow-sm hover:shadow-xl hover:shadow-primary/5"
                    >
                        Load More Insights
                        <HiChevronDown size={18} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default FeedbackSection;

